<div class="pinned-groups-area">
  <div>
    <p class="pinned-groups-area__header">
      {{ 'Statistics.SelectedDepartments' | translate }}
    </p>
  </div>
  <div class="pinned-groups-area__chip-wrapper">
    @if (hasSelectedGroups()) {
      @for (group of selectedGroups; track group) {
        @if (!group.hidden) {
          <app-chip
            [label]="getChipLabel(group)"
            [colorToken]="group.colorToken"
            (remove)="removeScoreSelection(group.id)"></app-chip>
        }
      }
    } @else {
      <div class="pinned-groups-area__no-selection">
        <div class="dv-icons pinned-groups-area__no-selection--icon">
          selection_search
        </div>
        <div class="pinned-groups-area__no-selection--text">
          {{ 'Statistics.NoSelectedDepartments' | translate }}
        </div>
      </div>
    }
  </div>
</div>
